export default "__VITE_ASSET__R$nm6Awd__"